/* POSH — خدمة شماغك جاهز:
   لو العميل داس "أضف" من غير ما يختار مقاس، نفتحله شاشة المقاسات بدل رسالة التنبيه. */
(function () {
  'use strict';

  function sizeChosen() {
    /* المقاس العام المختار فوق */
    var on = document.querySelector('[data-svc-size].is-on, .posh-svc__size.is-on, [data-size].is-on');
    return !!on;
  }

  function init() {
    var root = document.querySelector('[data-svc], .posh-svc');
    if (!root || root.dataset.poshPatched) return;
    root.dataset.poshPatched = '1';

    document.addEventListener('click', function (e) {
      var add = e.target.closest && e.target.closest('[data-add]');
      if (!add) return;
      if (sizeChosen()) return;

      var card = add.closest('.posh-svc__card, article');
      var opener = card && card.querySelector('[data-open-sheet]');
      if (!opener) return;

      /* امنع رسالة "اختار مقاسك الأول" وافتح شاشة المقاسات للشماغ ده */
      e.preventDefault();
      e.stopImmediatePropagation();
      opener.click();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();